import { render, staticRenderFns } from "./FichaVivienda.vue?vue&type=template&id=271c9fc4&scoped=true&"
import script from "./FichaVivienda.vue?vue&type=script&lang=js&"
export * from "./FichaVivienda.vue?vue&type=script&lang=js&"
import style0 from "./FichaVivienda.vue?vue&type=style&index=0&id=271c9fc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c9fc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCarousel,VCarouselItem,VIcon})
